require("../../scss/az-ships.scss");

import Application from "./application";

import MobileMenuBehavior from "../behaviours/mobile-menu-behaviour";
import EqualizeBehavior from "../behaviours/equalize-behaviour";
import ShortlistCount from "../jsx/shortlist/shortlist-count";
import ShortlistButton from '../jsx/shortlist/shortlist-button';
import SearchTemplateBasic from "../jsx/search/template-basic";
import CarouselBehaviour from "../behaviours/carousel-behaviour"
import TruncateBehaviour from "../behaviours/truncate-behaviour";
import ToggleClassBehavior from "../behaviours/toggle-class-behaviour";
import CruiseShipSearch from "../jsx/cruise-ship-search";
import HideShowBehaviour from "../behaviours/hide-show-behaviour";
import TabsBehaviour from "../behaviours/tabs-behaviour";
import ClassBehaviour from "../behaviours/class-behaviour";
import BlockEventBehaviour from "../behaviours/block-event-behaviour";



let config = {};
config.behaviours = {
    "MobileMenuBehaviour": new MobileMenuBehavior(),
    "EqualizeBehaviour": new EqualizeBehavior(),
    'CarouselBehaviour': new CarouselBehaviour(),
    'TruncateBehaviour': new TruncateBehaviour(),
    'ToggleClassBehaviour': new ToggleClassBehavior(),
    'HideShowBehaviour': new HideShowBehaviour(),
    'TabsBehaviour': new TabsBehaviour(),
    'ClassBehaviour': new ClassBehaviour(),
    'BlockEventBehaviour': new BlockEventBehaviour()
};

config.components = {
    "shortlist-count": ShortlistCount,
    "search-form": SearchTemplateBasic,
    "shortlist-button": ShortlistButton,
    'cruise-ship-search': CruiseShipSearch
}
new Application(config);